import { getFilterSearch } from '@/utils';

const loginCountKey = 'LOGIN_COUNT';
const codeUsedKey = 'CODE_USED';
// 返回微信login URL
export function getWechatLoginUrl(appId) {
  const redirectUrl = getLoginUrl(['code', 'state']);
  return `${location.protocol
  }//open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&scope=snsapi_base#wechat_redirect`;
}

/**
 * 获取登陆重定向地址
 * @param filter
 */
function getLoginUrl(filter: string[]) {
  const searchStr = getFilterSearch(filter);
  return `${location.protocol}//${location.host}${location.pathname}${searchStr}${location.hash}`;
}

// 登录微信
export function redirectLogin(appId) {
  const wechatUrl = getWechatLoginUrl(appId);
  console.log(`重定向：${wechatUrl}`);
  location.href = wechatUrl;
}

/**
 * 标记当前code已经使用
 * @param code
 * @returns
 */
export function setCodeUsed(code: string) {
  const usedCodeArr = getUsedCodeArr();
  usedCodeArr.push(code);
  return sessionStorage.setItem(codeUsedKey, Array.from(new Set(usedCodeArr)).toString());
}

function getUsedCodeArr() {
  const usedCodeStr = sessionStorage.getItem(codeUsedKey) || '';
  return usedCodeStr.split(',');
}

/**
 * 是否code已经使用过
 * @param code
 * @returns
 */
export function isCodeUsed(code: string) {
  console.log(getUsedCodeArr());
  return getUsedCodeArr().indexOf(code) > -1;
}

/**
 * 增加登录次数
 * @returns
 */
export function addLoginCount() {
  const curLoginCount = getLoginCount();
  return sessionStorage.setItem(loginCountKey, `${curLoginCount + 1}`);
}

export function resetLoginCount() {
  return sessionStorage.removeItem(loginCountKey);
}

/**
 * 获取登录次数
 * @returns
 */
function getLoginCount() {
  return +(sessionStorage.getItem(loginCountKey) || 0);
}

export function isLoginCountOver(max: number) {
  return getLoginCount() > max;
}
